// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f79f04e7","732":"3dce83d8","754":"24ab7640","941":"25e8f38d"}[chunkId] + ".chunk.js";
};